// LineChart.js

import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

// Register the necessary components for Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineChart = ({ data }) => {
    // Extract the dates and values from the data
    const dates = data.map(item => new Date(item.date).toLocaleString());
    const values = data.map(item => item["Natural Remedies"]);

    // Data for the chart
    const chartData = {
        labels: dates,
        datasets: [
            {
                label: 'Natural Remedies',
                data: values,
                fill: false,
                borderColor: 'rgba(0, 123, 255, 1)',  // Line color
                tension: 0.1, // Line smoothness
            },
        ],
    };

    // Chart options
    const options = {
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false, // Disable the grid on the x-axis
                },
                ticks: {
                    autoSkip: true, // Auto-skip ticks
                    maxTicksLimit: 10, // Limit the number of ticks shown
                },
            },
            y: {
                grid: {
                    display: false, // Disable the grid on the y-axis
                },
            },
        },
    };

    return (
        <div>
            <Line data={chartData} options={options} />
        </div>
    );
};

export default LineChart;
